export enum DocumentType {
  STANDARD = "STANDARD",
  WALLET = "WALLET",
  CALENDAR = "CALENDAR",
}
